import script from "./ConfigServicesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigServicesSection.vue?vue&type=script&setup=true&lang=js"

import "./ConfigServicesSection.vue?vue&type=style&index=0&id=28461b56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28461b56"]])

export default __exports__